import React, { useState, useEffect } from "react";
import { ArrowRight } from "lucide-react";
import "../Styles/newspage.css";

const ITEMS_PER_PAGE = 12;
const MIN_PAGES = 3; // ✅ always show at least 5 page numbers, like the blog page

// ---- News data ---------------------------------------------------------
const newsData = [
  {
    id: 15,
    title:
      "Lavanya Sankar S has been appointed as Head – Human Resources at Springbord!",
    summary:
      "This exciting leadership milestone marks another significant step in her professional journey and reflects her commitment to driving people excellence, strengthening organizational culture, and creating meaningful workplace experiences.",
    detail: [
      "This exciting leadership milestone marks another significant step in her professional journey and reflects her commitment to driving people excellence, strengthening organizational culture, and creating meaningful workplace experiences.",
      "With her passion for human resources, people development, and strategic HR practices, Lavanya brings valuable perspectives to the evolving world of people management.",
       "As organizations continue to navigate transformation, innovation, and changing workforce expectations, strong HR leadership plays a vital role in building high-performing teams, nurturing talent, fostering employee engagement, and shaping future-ready workplaces.",
       "As organizations continue to navigate transformation, innovation, and changing workforce expectations, strong HR leadership plays a vital role in building high-performing teams, nurturing talent, fostering employee engagement, and shaping future-ready workplaces.",
       "As organizations continue to navigate transformation, innovation, and changing workforce expectations, strong HR leadership plays a vital role in building high-performing teams, nurturing talent, fostering employee engagement, and shaping future-ready workplaces.",
       "Wishing you an inspiring and successful journey in your new leadership role!",
    
     
        
        
      
    ],
    name: "Lavanya Sankar S",
    image: "/lav.png",
  },
  {
    id: 14,
    title:
      "Rajinder Natarajan has been appointed as Senior Director – Talent Acquisition at Aziro!",
    summary:
      "This exciting leadership appointment marks another significant milestone in Rajinder’s professional journey and reflects the importance of strategic talent leadership in today's rapidly evolving business landscape.",
    detail: [
      "This exciting leadership appointment marks another significant milestone in Rajinder’s professional journey and reflects the importance of strategic talent leadership in today's rapidly evolving business landscape.",
      "As organizations continue to navigate changing workforce dynamics, technological advancements, and growing business demands, Talent Acquisition plays a vital role in building strong teams, attracting exceptional talent, and creating sustainable organizational growth.",
       "In his new leadership role, Rajinder will have an opportunity to contribute to strengthening talent acquisition strategies, driving impactful hiring initiatives, building high-performing teams, and aligning talent capabilities with the organization's business vision.",
       "His appointment also highlights the growing importance of strategic recruitment leadership in shaping the future of work and creating a competitive talent ecosystem.",
       "Congratulations, Rajinder Natarajan!",
       "Wishing you great success in this new chapter of your professional journey. May this role bring exciting opportunities, meaningful achievements, and many more milestones ahead!",
    
     
        
        
      
    ],
    name: "Rajinder Natarajan",
    image: "/raji.png",
  },
  {
    id: 13,
    title:
      "Divya Kumar appointment as Head of Human Resources – Director at Weaver.",
    summary:
      "With over two decades of corporate experience, Divya Kumar brings extensive expertise in human resources, people strategy, talent engagement, organizational development, employee experience, and building high-performing teams. Her professional journey reflects a strong commitment to creating people-centric workplaces, strengthening organizational culture, and aligning HR initiatives with business objectives.",
    detail: [
      "With over two decades of corporate experience, Divya Kumar brings extensive expertise in human resources, people strategy, talent engagement, organizational development, employee experience, and building high-performing teams. Her professional journey reflects a strong commitment to creating people-centric workplaces, strengthening organizational culture, and aligning HR initiatives with business objectives..",
      "Throughout her career, Divya has contributed to several impactful people and organizational initiatives, with a focus on enhancing employee engagement, improving workplace effectiveness, driving capability development, and fostering a culture of continuous improvement.",
       "Her achievements include recognition for her contributions to employee engagement and HR excellence. She was honoured as the Future Woman Leader of the Year at the 7th Future Woman Leader Digital Summit and Awards 2021, acknowledging her contribution to HR practices, workplace culture, and people management. She has also received recognition for employee engagement initiatives and continues to demonstrate her commitment to innovation and excellence in the HR profession.",
       "As she steps into this leadership role at Weaver, her experience and people-first approach will be valuable in strengthening HR strategy, nurturing talent, empowering teams, and supporting the organization's continued growth. Leadership in HR is not just about managing people; it is about inspiring potential, building trust, enabling transformation, and creating an environment where individuals and businesses thrive together.",
       "May this new role bring exciting opportunities, meaningful achievements, and continued excellence in people leadership.",
       "Congratulations, Divya Kumar! Wishing you continued success and many more milestones ahead.",
    
     
        
        
      
    ],
    name: "Divya Kumar",
    image: "/div.png",
  },
  {
    id: 13,
    title:
      "Bhuvanesh devi Rajan has been appointed as Director – HR at Reveleer Global Capability Center!",
    summary:
      "This remarkable career milestone marks another exciting chapter in your professional journey, reflecting your dedication to Human Resources, people leadership, and building impactful workplace experiences.",
    detail: [
      "This remarkable career milestone marks another exciting chapter in your professional journey, reflecting your dedication to Human Resources, people leadership, and building impactful workplace experiences.",
      "With extensive experience in Human Resources, strategic people management, talent development, employee engagement, and HR operations, Bhuvanesh brings valuable expertise to her new leadership role. Her professional journey across leading organizations reflects a strong commitment to aligning people strategies with business objectives and fostering an environment where employees and organizations can thrive together.",
       "As Director – HR at Reveleer Global Capability Center, she will play an important role in shaping people strategies, strengthening organizational culture, supporting talent development, and enhancing the overall employee experience. Her leadership will contribute to building a workplace that encourages collaboration, continuous learning, inclusion, and sustainable growth.",
       "As global capability centers continue to evolve as strategic business hubs, the role of HR leadership becomes increasingly important in connecting people, performance, and organizational purpose. Leaders who understand both business priorities and employee aspirations are instrumental in creating workplaces where talent can flourish.",
       "Wishing Bhuvanesh devi Rajan continued success in this exciting new chapter!",
       "May this journey bring new opportunities, meaningful achievements, and many more milestones as you continue to make a positive impact on the HR community and the world of work.",
    
     
        
        
      
    ],
    name: "Bhuvanesh devi Rajan",
    image: "/devi.png",
  },
  {
    id: 12,
    title:
      "T.K.B.Arun Kartik has been appointed as Head – Global Recruitment at ELIXIR Global",
    summary:
      "With extensive experience across Human Resources, Talent Acquisition, Recruitment, and people leadership, Arun Kartik brings valuable industry experience and a strong understanding of building high-performing recruitment teams and talent strategies.",
    detail: [
      "With extensive experience across Human Resources, Talent Acquisition, Recruitment, and people leadership, Arun Kartik brings valuable industry experience and a strong understanding of building high-performing recruitment teams and talent strategies.",
      "In his new role, he will be responsible for driving global recruitment initiatives, strengthening talent acquisition strategies, building recruitment capabilities, and supporting ELIXIR Global’s growth through the right talent and leadership.",
       "Leadership appointments such as these mark an important step in strengthening organizational capabilities and creating a future-ready talent ecosystem.",
       "👏Congratulations, T.K.B.Arun Kartik!",
       "Wishing you continued success in your new role and an exciting journey ahead at ELIXIR Global.",
       "May this new chapter bring new opportunities, meaningful impact, and many more milestones in your professional journey.",
    
     
        
        
      
    ],
    name: "T.K.B.Arun Kartik",
    image: "/ar_k.png",
  },
  {
    id: 11,
    title:
      " Dr. Arun Mani has been appointed as Vice President – Human Resources at Casagrand Premier Builder Limited.",
    summary:
      "This new leadership role marks another significant milestone in Dr. Arun Mani’s professional journey, bringing together strategic HR leadership, people development, organizational culture, and business growth.",
    detail: [
      "As organizations continue to navigate a rapidly evolving workplace, strong people leadership plays a vital role in building high-performing teams, strengthening employee experiences, developing future-ready talent, and creating a culture that supports sustainable business growth.",
      "In his new role as Vice President – Human Resources, Dr. Arun Mani will contribute to shaping people strategies and HR initiatives that support organizational priorities and the continued growth of the business.",
       "Congratulations, Dr. Arun Mani!",
       "Wishing you continued success in this new leadership responsibility. May this new chapter bring exciting opportunities, meaningful impact, and greater milestones ahead.",
    
     
        
        
      
    ],
    name: "Dr. Arun Mani ",
    image: "/arun_mani.jpeg",
  },
  {
    id: 10,
    title:
      "Yuvaraj Kuppan has been appointed as Assistant Vice President – Talent Acquisition at UDS Group.",
    summary:
      "This new role marks an exciting milestone in Yuvaraj Kuppan’s professional journey and reflects his continued contribution to the evolving world of talent acquisition and people leadership.",
    detail: [
      "Talent Acquisition has become a strategic business function — going beyond hiring to building strong talent pipelines, strengthening employer brands, engaging the right talent, and supporting organizations in building future-ready teams.",
      "In his new role as Assistant Vice President – Talent Acquisition, Yuvaraj will play an important role in driving talent acquisition strategies, strengthening hiring capabilities, enabling leadership and business growth, and building high-performing teams aligned with organizational goals.",
       "Leadership transitions such as these highlight the importance of experienced talent professionals in shaping the future of organizations and creating meaningful opportunities for people and businesses..",
       "Congratulations, Yuvaraj Kuppan!",
         "Wishing you continued success in your new leadership role at UDS Group. May this new chapter bring exciting opportunities, impactful initiatives, and many more milestones in your journey.",
    
     
        
        
      
    ],
    name: "Yuvaraj Kuppan",
    image: "/yuva_kuppan.jpeg",
  },
  {
    id: 9,
    title:
      " Surendar Parthiban has been appointed as Head of Human Resources at Precision Infomatic (M) Private Limited",
    summary:
      "With his experience and expertise in Human Resources, talent management, employee engagement, people strategy, and organizational development, Surendar takes on this important leadership role with an opportunity to contribute significantly to the organization’s people and culture agenda.",
    detail: [
      "With his experience and expertise in Human Resources, talent management, employee engagement, people strategy, and organizational development, Surendar takes on this important leadership role with an opportunity to contribute significantly to the organization’s people and culture agenda.",
      "As Head of Human Resources, he will play a key role in strengthening people practices, driving employee engagement, supporting talent development, and aligning HR strategies with the organization’s business objectives.",
       "His leadership will be instrumental in building a strong, future-ready workplace culture and enabling employees and teams to achieve their full potential.",
       "Wishing Surendar Parthiban great success in his new role and an exciting journey ahead at Precision Infomatic!",
    
     
        
        
      
    ],
    name: "Surendar Parthiban  ",
    image: "/surend.png",
  },
  {
    id: 8,
    title:
      " Pakshirajan Govindan has been appointed as Vice President – Global Head – Delivery & Operations at Highbrow Technology Inc.",
    summary:
      "With close to 18 years of professional experience spanning Talent Acquisition, Talent Management, Organizational Development, and building high-performing teams, Pakshirajan brings a strong combination of people leadership, strategic thinking, business alignment, and operational excellence to his new role.",
    detail: [
      "With close to 18 years of professional experience spanning Talent Acquisition, Talent Management, Organizational Development, and building high-performing teams, Pakshirajan brings a strong combination of people leadership, strategic thinking, business alignment, and operational excellence to his new role.",
      "In his new leadership position, he will be responsible for driving global delivery and operations, strengthening organizational capabilities, enabling effective execution, and aligning talent and operational strategies with business priorities.",
       "His career journey reflects a consistent focus on building high-growth teams, strengthening recruitment and talent practices, and creating people strategies that support business transformation. His experience in working across talent and business functions positions him well to contribute to Highbrow Technology’s continued global growth.",
       "Highbrow Technology Inc. is a global technology solutions provider with capabilities across Generative AI, LLM training, Prompt Engineering, Data Engineering, Cloud Solutions, Security, Infrastructure, Workday, SAP, PEGA, Salesforce, and ServiceNow. The company has a presence across the USA and India and continues to expand its technology capabilities globally.",
       "As organizations increasingly focus on scalable operations, digital transformation, AI-led innovation, and future-ready talent, strong leadership at the intersection of people, technology, delivery, and business strategy becomes increasingly important.",
       "We congratulate Pakshirajan Govindan on this exciting new chapter and wish him tremendous success in his new role at Highbrow Technology Inc.",
       "Wishing you continued success as you lead global delivery and operations, build high-performing teams, and create greater impact in this new leadership journey.",
     
        
        "Congratulations, Charles Monish, on this well-deserved career milestone! ",
           "We wish you great success in your new role and look forward to seeing the impact you create at Maximl.",
      
    ],
    name: "Pakshirajan Govindan ",
    image: "/pak.jpeg",
  },
  {
    id: 7,
    title:
      " Divya R S has been appointed as Head of Human Resources at Cloverbridge.",
    summary:
      "This appointment marks an exciting new chapter in Divya’s professional journey and reflects the growing importance of strategic people leadership in today’s rapidly evolving workplace.",
    detail: [
      "This appointment marks an exciting new chapter in Divya’s professional journey and reflects the growing importance of strategic people leadership in today’s rapidly evolving workplace.",
      "As Head of Human Resources, Divya will play a key role in shaping and strengthening the organization’s people strategy, fostering a positive employee experience, developing a high-performance culture, and aligning HR initiatives with business objectives.",
       "In an era where organizations are increasingly recognizing that people are at the heart of sustainable growth, HR leadership has evolved far beyond traditional people administration. Today, HR leaders are strategic business partners who influence culture, leadership development, talent management, employee engagement, organizational effectiveness, and the overall future of work.",
       "Divya’s new role at Cloverbridge presents an opportunity to contribute to these critical areas while supporting the organization in building an environment where people can learn, grow, collaborate, and perform at their best.",
       "Congratulations, Divya R S, on this well-deserved leadership appointment!",
       "We wish you great success in your new role and look forward to seeing the impact of your leadership in shaping the people and culture journey at Cloverbridge.",
     
        
        "Congratulations, Charles Monish, on this well-deserved career milestone! ",
           "We wish you great success in your new role and look forward to seeing the impact you create at Maximl.",
      
    ],
    name: "Divya R ",
    image: "/di.jpeg",
  },
   {
    id: 6,
    title:
      "Charles Monish has been appointed as HR Manager at Maximl, marking an exciting new chapter in his professional journey.",
    summary:
      "With a strong background in Human Resources, Talent Management, Employee Relations, HR Operations, Recruitment, and people-focused initiatives, Charles brings valuable experience and a strategic approach to his new role. His journey reflects a commitment to building strong workplace practices, supporting employees, and creating people-centric organizational environments",
    detail: [
      "With a strong background in Human Resources, Talent Management, Employee Relations, HR Operations, Recruitment, and people-focused initiatives, Charles brings valuable experience and a strategic approach to his new role. His journey reflects a commitment to building strong workplace practices, supporting employees, and creating people-centric organizational environments.",
      "As organizations continue to navigate the evolving world of work, the role of HR has become increasingly important in shaping workplace culture, employee experience, talent development, engagement, and organizational growth. Leaders like Charles play a vital role in connecting people strategies with business objectives and creating workplaces where employees can grow and contribute meaningfully.",
       "In his new role at Maximl, Charles will have an opportunity to further contribute to strengthening people practices, supporting organizational growth, and building an engaging and high-performing workplace culture.",
     
        
        "Congratulations, Charles Monish, on this well-deserved career milestone! ",
           "We wish you great success in your new role and look forward to seeing the impact you create at Maximl.",
      
    ],
    name: "Charles Monish",
    image: "/charles.png",
  },
  {
    id: 5,
    title:
      "Sridhar Thiruppathi has been appointed as Strategic People Partner at Rently Software Development.",
    summary:
      "This new appointment marks another significant step in Sridhar’s journey as a people and HR professional, bringing together his experience in People & Culture, HR strategy, talent management, employee experience, organizational development, and business partnering.",
    detail: [
      "This new appointment marks another significant step in Sridhar’s journey as a people and HR professional, bringing together his experience in People & Culture, HR strategy, talent management, employee experience, organizational development, and business partnering.",
      "As organizations continue to evolve in a rapidly changing world of work, the role of HR is moving beyond traditional people management toward becoming a true strategic business partner. In this context, the Strategic People Partner role plays a crucial part in connecting people, culture, business priorities, leadership, and organizational growth.",
       "Sridhar’s experience in working across people-focused initiatives and building strong organizational practices positions him well to contribute to this evolving people agenda at Rently.",
        "In his new role, he will be part of the journey toward strengthening people strategies, enabling high-performing teams, supporting leaders, enhancing employee experiences, and building a culture that aligns people capabilities with business objectives. ",
        "The future of work demands HR leaders who can understand both people and business, create meaningful employee experiences, develop future-ready talent, and help organizations navigate continuous transformation. Strategic People Partners are increasingly becoming a critical bridge between leadership teams and the workforce. ",
        "Sridhar’s appointment reflects the growing importance of strategic people leadership in creating organizations where people, performance, purpose, and business growth move together. ",
        "Congratulations to Sridhar Thiruppathi on this exciting new role! ",
           "We wish him continued success and look forward to seeing the impact he creates at Rently as he contributes to its people, culture, and organizational growth journey.",
      
    ],
    name: "Sridhar Thiruppathi",
    image: "/sri.png",
  },
  {
    id: 4,
    title:
      "Aravind Dhandapani has been appointed as Associate Director – Talent Acquisition and Management at ALAM CAPITAL BHD.",
    summary:
      "With a strong background in Talent Acquisition, Recruitment Strategy, Talent Management, Leadership Hiring, and People Development, Aravind has built valuable expertise in identifying, attracting, and developing high-performing talent.",
    detail: [
      "With a strong background in Talent Acquisition, Recruitment Strategy, Talent Management, Leadership Hiring, and People Development, Aravind has built valuable expertise in identifying, attracting, and developing high-performing talent.",
      "In his new role, Aravind will contribute to strengthening talent acquisition strategies, building high-impact teams, enhancing recruitment processes, and supporting the organisation’s people and talent agenda.",
       "His experience in working across the talent lifecycle and understanding evolving workforce expectations positions him well to make a meaningful contribution to ALAM CAPITAL BHD’s continued growth and talent strategy.",
        "We wish Aravind Dhandapani continued success in this new chapter and look forward to seeing his impact in shaping talent and people strategies at ALAM CAPITAL BHD. ",
          "Congratulations to Aravind Dhandapani on this exciting new leadership journey! ",
           "We wish him continued success and look forward to seeing the impact he creates in his new role.",
      
    ],
    name: "Aravind Dhandapani",
    image: "/a.png",
  },
  {
    id: 3,
    title:
      "Rupesh Chandrasekharan has been appointed as Vice President at TRUSPEQ: SAP Gold Partner.",
    summary:
      "With his extensive experience in Talent Acquisition, Recruitment Strategy, Leadership, and People Management, Rupesh brings valuable expertise to his new role.",
    detail: [
      "With his extensive experience in Talent Acquisition, Recruitment Strategy, Leadership, and People Management, Rupesh brings valuable expertise to his new role.",
      "As TRUSPEQ: SAP Gold Partner continues its growth journey, his leadership will play an important role in strengthening talent strategies, building high-performing teams, and shaping a future-ready workforce.",
      
    ],
    name: "Rupesh Chandrasekharan",
    image: "/rupesh.png",
  },
  {
    id: 1,
    title:
      "Kadhar Mohammuad M K has been appointed as Director – Human Resources at Staples India.",
    summary:
      "With over 20 years of experience spanning Global Capability Centres (GCCs), technology, media, manufacturing and consulting, Kadhar brings a strong track record in HR transformation, talent management, organisational development and workforce strategy.",
    detail: [
      "With over 20 years of experience spanning Global Capability Centres (GCCs), technology, media, manufacturing and consulting, Kadhar brings a strong track record in HR transformation, talent management, organisational development and workforce strategy.",
      "Throughout his career, he has partnered closely with business leaders to build and scale HR functions, strengthen organisational culture, develop leadership capabilities and create people-centric workplaces.",
      "In his new role at Staples India, Kadhar will play a key role in strengthening the organisation's people strategy, culture, employee experience and talent agenda as the company continues its growth journey.",
      "His leadership journey has also been recognised through accolades including the HR Leader Award 2026 and his inclusion among the Top 50 HR Leaders to Follow in 2025.",
    ],
    name: "Kadhar Mohammuad MK",
    image: "/Np_Kaadhar_img.png",
  },
  {
    id: 2,
    title:
      "Bharathkumar Mayakrishnan has been appointed as Vice President – Human Resources at adamsbridge.",
    summary:
      "With nearly 20 years of experience in Human Resources and People Management, Bharathkumar brings deep expertise across HR Business Partnering, Employee Relations, Talent Development, HR Analytics, Personnel Management, and Organizational Growth.",
    detail: [
      "With nearly 20 years of experience in Human Resources and People Management, Bharathkumar brings deep expertise across HR Business Partnering, Employee Relations, Talent Development, HR Analytics, Personnel Management, and Organizational Growth.",
      "Before joining adamsbridge, he served as Head of Human Resources at finzly, following a leadership journey that includes senior HR roles at Mastech InfoTrellis, Sutherland, Atos, KGB Credit Services, Perot Systems, Optimus Global Services, B'Risk Corporate Services, and Cybernet Slash Support.",
      "In his new role, Bharathkumar will play a strategic role in strengthening the people function at adamsbridge, driving employee-focused initiatives, developing talent, and aligning people strategy with organizational growth.",
    ],
    name: "Bharathkumar Mayakrishnan",
    image: "/Np_Bharath_img.png",
  },
   
];

// ---- Reusable image panel (image only) — used by the LIST card ---------
const NewsImagePanel = ({ image, name }) => (
  <div className="ow-news-imgwrap">
    <img src={image} alt={name} className="ow-news-img" />
  </div>
);

// ---- LIST CARD — unchanged: 3-column layout with Read More button ------
const NewsCard = ({ item, buttonLabel, onButtonClick, icon, cardIndex }) => (
  <div className={`ow-news-card ow-news-card-${cardIndex}`}>
    {/* Column 1 */}
    <div className="ow-news-col1">
      <div className="ow-news-vline" />
      <h3 className="ow-news-cardtitle">
        <span className="ow-news-name">{item.name}</span>
        {item.title.substring(item.name.length)}
      </h3>
    </div>

    {/* Column 2 */}
    <div className="ow-news-col2">
      <div className="ow-news-thinline" />
      <div className="ow-news-col2-inner">
        <div className="ow-news-col2-text">
          <p className="ow-news-summary">{item.summary}</p>
        </div>
        <button className="ow-news-readmore" onClick={onButtonClick}>
          {buttonLabel} {icon}
        </button>
      </div>
    </div>

    {/* Column 3 */}
    <div className="ow-news-col3">
      <NewsImagePanel image={item.image} name={item.name} />
    </div>
  </div>
);

// ---- DETAIL / "READ MORE" PAGE — no card box, just the content ---------
const NewsDetail = ({ item, cardIndex }) => (
  <div className={`ow-newsdetail-wrap ow-newsdetail-wrap-${cardIndex}`}>
    <div className="ow-newsdetail-left">
      <div className="ow-newsdetail-titlerow">
        <div className="ow-newsdetail-vline" />
        <h3 className="ow-newsdetail-title">
          <span className="ow-news-name">{item.name}</span>
          {item.title.substring(item.name.length)}
        </h3>
      </div>

      <div className="ow-newsdetail-hline" />

      <div className="ow-newsdetail-content">
        {item.detail.map((para, idx) => (
          <p key={idx} className="ow-newsdetail-para">
            {para}
          </p>
        ))}
      </div>
    </div>

    <div className="ow-newsdetail-right">
      <img
        src={item.image}
        alt={item.name}
        className="ow-newsdetail-img"
      />
    </div>
  </div>
);

// ---- Main page ----------------------------------------------------------
const Newspage = () => {
  const [selectedId, setSelectedId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  const handleReadMore = (id) => {
    setSelectedId(id);
    window.history.pushState({ newsDetail: true }, "");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    const handlePopState = () => {
      setSelectedId(null);
    };

    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, []);

  const selectedItem = newsData.find((n) => n.id === selectedId);
  const selectedIndex = newsData.findIndex((n) => n.id === selectedId) + 1;

  // ---- Pagination ----
  const realTotalPages = Math.ceil(newsData.length / ITEMS_PER_PAGE);
  const totalPages = Math.max(realTotalPages, MIN_PAGES); // ✅ always at least MIN_PAGES

  const pageNews = newsData.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  const handlePageChange = (n) => {
    if (n < 1 || n > totalPages) return;
    setCurrentPage(n);
    window.scrollTo(0, 0);
  };

  return (
    <div className="ow-news-page">
      {!selectedItem && (
        <>
          <div className="ow-news-badge">
            <img src="/Np_icon.png" alt="" className="ow-news-badge-icon" />
            LATEST UPDATE
          </div>

          <h1 className="ow-news-heading">
            Latest <span className="ow-news-heading-accent">News</span>
          </h1>
          <div className="ow-news-underline" />
        </>
      )}

      <div className="ow-news-list">
        {selectedItem ? (
          <NewsDetail item={selectedItem} cardIndex={selectedIndex} />
        ) : (
          pageNews.map((item, idx) => (
            <NewsCard
              key={item.id}
              item={item}
              buttonLabel="Read More"
              icon={<ArrowRight size={16} />}
              onButtonClick={() => handleReadMore(item.id)}
              cardIndex={idx + 1}
            />
          ))
        )}
      </div>

      {/* PAGINATION — only on list view, ALWAYS shows (min 5 pages, like blog page) */}
      {!selectedItem && (
        <div className="ow-news-pagination">
          <button
            className="ow-news-page-btn"
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            ← Previous
          </button>

          <div className="ow-news-page-numbers">
            {Array.from({ length: totalPages }, (_, i) => i + 1).map((n) => {
              const isDisabled = n > realTotalPages;
              return (
                <span
                  key={n}
                  className={`${n === currentPage ? "active" : ""} ${
                    isDisabled ? "disabled" : ""
                  }`}
                  onClick={() => !isDisabled && handlePageChange(n)}
                >
                  {n}
                </span>
              );
            })}
          </div>

          <button
            className="ow-news-page-btn"
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === realTotalPages}
          >
            Next →
          </button>
        </div>
      )}
    </div>
  );
};

export default Newspage;